import { Select as MantineSelect } from "@mantine/core";
import { Select } from "react-hook-form-mantine";
import { useGetSessions } from "../../api/session";
import { useGetAllSpeakers } from "../../api/speakers";
import { useGetSponsors } from "../../api/sponsors";
import { useGetPages } from "../../api/pages";

const LINK_TYPES = [
  { value: "none", label: "None" },
  { value: "documents", label: "My documents" },
  { value: "agenda", label: "Agenda" },
  { value: "session", label: "Session" },
  { value: "speaker", label: "Speaker" },
  { value: "sponsor", label: "Sponsor" },
  { value: "page", label: "Page" },
  { value: "myProfile", label: "My profile" },
];

const AnnouncementLinkFields = ({ control, watch, setValue, eventId }) => {
  const linkType = watch("linkType");

  const { data: sessions } = useGetSessions(
    { eventId },
    { enabled: linkType === "session" }
  );
  const { data: speakers } = useGetAllSpeakers(
    { eventId, limit: 250 },
    { enabled: linkType === "speaker" }
  );
  const { data: sponsors } = useGetSponsors(
    { eventId, limit: 250 },
    { enabled: linkType === "sponsor" }
  );
  const { data: pages } = useGetPages(
    { eventId, all: true },
    { enabled: linkType === "page" }
  );

  const targetOptions = {
    session: sessions?.map((s) => ({ value: String(s.id), label: s.title })),
    speaker: speakers?.data?.map((s) => ({
      value: String(s.id),
      label: `${s.firstName} ${s.lastName}`,
    })),
    sponsor: sponsors?.data?.map((s) => ({
      value: String(s.id),
      label: s.name,
    })),
    page: pages?.map((p) => ({ value: String(p.id), label: p.title })),
  }[linkType];

  const targetLabel = LINK_TYPES.find((t) => t.value === linkType)?.label;

  return (
    <>
      <MantineSelect
        label="Opens in app"
        mt="sm"
        data={LINK_TYPES}
        value={linkType}
        onChange={(value) => {
          setValue("linkType", value, { shouldDirty: true });
          setValue("linkTargetId", null, { shouldDirty: true });
        }}
        allowDeselect={false}
      />
      {["session", "speaker", "sponsor", "page"].includes(linkType) && (
        <Select
          label={targetLabel}
          placeholder={`Select ${targetLabel.toLowerCase()}`}
          mt="sm"
          name="linkTargetId"
          control={control}
          data={targetOptions ?? []}
          searchable
          withAsterisk
        />
      )}
    </>
  );
};

export default AnnouncementLinkFields;
